import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "@/pages/Landing";
import ScrollProgress from "@/components/ScrollProgress";
import ScrollToTop from "@/components/ScrollToTop";
import { Toaster } from "sonner";
import { COUNTRY_LIST } from "@/data/countries";
import { SERVICES_LIST } from "@/data/services";

// Code-split secondary routes so the initial bundle stays slim for Core Web Vitals.
// Landing (`/`) is kept eagerly imported because it's the LCP page.
const CountryPage = lazy(() => import("@/pages/CountryPage"));
const TestPrepPage = lazy(() => import("@/pages/TestPrepPage"));
const StatisticsPage = lazy(() => import("@/pages/StatisticsPage"));
const ServicePage = lazy(() => import("@/pages/ServicePage"));
const CareersPage = lazy(() => import("@/pages/CareersPage"));
const NagpurPage = lazy(() => import("@/pages/NagpurPage"));
const AdminPage = lazy(() => import("@/pages/AdminPage"));

function RouteFallback() {
  return (
    <div
      className="min-h-screen grid place-items-center bg-[#FAFAFA] text-[#282829]"
      data-testid="route-fallback"
    >
      <div className="flex items-center gap-3">
        <div className="w-3 h-3 rounded-full bg-[#c92e34] animate-bounce" />
        <div className="w-3 h-3 rounded-full bg-[#282829] animate-bounce [animation-delay:120ms]" />
        <div className="w-3 h-3 rounded-full bg-[#c92e34] animate-bounce [animation-delay:240ms]" />
      </div>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <ScrollProgress />
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/test-prep" element={<TestPrepPage />} />
            <Route path="/statistics" element={<StatisticsPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/study-abroad-consultants-nagpur" element={<NagpurPage />} />
            <Route path="/admin" element={<AdminPage />} />
            {COUNTRY_LIST.map((c) => (
              <Route
                key={c.slug}
                path={`/study-in-${c.slug}`}
                element={<CountryPage slug={c.slug} />}
              />
            ))}
            {SERVICES_LIST.map((s) => (
              <Route
                key={s.slug}
                path={`/service/${s.slug}`}
                element={<ServicePage slug={s.slug} />}
              />
            ))}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
